import React from "react";
import Modal from "react-modal";
import { TermsOfServiceModalStyle } from "../../util/ModalStyle";

const TermsOfServiceModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={TermsOfServiceModalStyle}
      ariaHideApp={false}
    >
      <TermsOfServiceContent onRequestClose={onRequestClose} />
    </Modal>
  );
};

const TermsOfServiceContent = ({ onRequestClose }) => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>서비스 이용약관</h2>
        <button style={styles.closeButton} onClick={onRequestClose}>
          ✕
        </button>
      </div>
      <div style={styles.content}>
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>취소 및 환불 규정</h3>
          <p style={styles.paragraph}>
            본 서비스는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 결제일로부터 7일 이내에는 청약철회를 요청할 수 있습니다.
            다만, 아래의 경우에는 청약철회가 제한될 수 있습니다.
          </p>
          <ul style={styles.list}>
            <li>결제 후 서비스가 즉시 제공되거나, 법률상담 또는 서류작성 등 용역의 제공이 이미 개시된 경우</li>
            <li>이용자의 동의 하에 서비스가 진행되어 사실상 회수가 불가능한 경우</li>
            <li>기타 「전자상거래 등에서의 소비자보호에 관한 법률」 및 관련 법령에서 정한 청약철회 제한 사유에 해당하는 경우</li>
          </ul>
          <p style={styles.paragraph}>
            환불이 가능한 경우, 환불은 청약철회 접수일로부터 3~7영업일 이내에 PG사(카카오페이 등)를 통해 처리됩니다.
            자세한 내용은 고객센터 또는 1:1 문의를 통해 안내받으실 수 있습니다.
          </p>
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>제1조(청약철회 및 환불)</h3>
          <p style={styles.paragraph}>
            ① 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 결제일로부터 7일 이내 청약철회를 요청할 수 있습니다.
          </p>
          <p style={styles.paragraph}>
            ② 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 청약철회가 제한됩니다.
          </p>
          <ul style={styles.list}>
            <li>결제 후 법률상담, 문서작성 등 서비스 제공이 이미 개시된 경우</li>
            <li>서비스 특성상 회수 또는 재이용이 불가능한 경우</li>
            <li>기타 관련 법령에 따라 청약철회가 제한되는 경우</li>
          </ul>
          <p style={styles.paragraph}>
            ③ 회사는 이용자의 청약철회 요청이 정당하다고 인정될 경우, 해당 결제금액을 3~7영업일 이내에 환불합니다. 환불은 결제수단을 통해 처리되며, PG사(카카오페이 등)의 환불 정책을 따릅니다.
          </p>
          <p style={styles.paragraph}>
            ④ 환불 요청 및 관련 문의는 고객센터 또는 1:1 문의를 통해 접수할 수 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #e0e0e0",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    margin: 0,
    color: "#000",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#666",
    padding: 0,
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    flex: 1,
    overflowY: "auto",
    paddingRight: "8px",
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#000",
  },
  paragraph: {
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#333",
    marginBottom: "12px",
    whiteSpace: "pre-wrap",
  },
  list: {
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#333",
    paddingLeft: "20px",
    marginBottom: "12px",
  },
};

export default TermsOfServiceModal;

